module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "day"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.day.date, 'dd. Do MMM ')))]), _c('div', {
    staticClass: "events"
  }, _vm._l((_vm.day.events), function(event) {
    return _c('div', {
      staticClass: "event"
    }, [_c('dl', [_c('dt', [_vm._v(_vm._s(event.badge))]), _c('dd', [_vm._v(_vm._s(_vm._f("moment")(event.start, 'HH:mm')) + " - " + _vm._s(event.name))])])])
  }), 0), _c('span', {
    staticClass: "bold"
  }, [_vm._v("PAX:")]), _c('span', [_vm._v(" " + _vm._s(_vm.day.pax))]), (_vm.day.sold_out) ? _c('span', {
    staticClass: "bold"
  }, [_vm._v(" ausverkauft!")]) : _vm._e(), _c('div', [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ende VA ca.:")]), (_vm.day.planned_end) ? _c('span', [_vm._v(" " + _vm._s(_vm.day.planned_end.split(':').slice(0, 2).join(':')) + " Uhr")]) : _c('span', [_vm._v(" -")])]), (_vm.day.production_managers.length > 0) ? _c('div', {
    staticClass: "production-managers"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PL:  ")]), _vm._l((_vm.day.production_managers), function(manager) {
    return _c('span', {
      staticClass: "manager"
    }, [_vm._v(_vm._s(manager))])
  })], 2) : _vm._e(), (_vm.day.day_managers.length > 0) ? _c('div', {
    staticClass: "day-managers"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TL:  ")]), _vm._l((_vm.day.day_managers), function(manager) {
    return _c('span', {
      staticClass: "manager"
    }, [_vm._v(_vm._s(manager))])
  })], 2) : _vm._e(), (_vm.day.managers.length > 0) ? _c('div', {
    staticClass: "managers"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("AL:  ")]), _vm._l((_vm.day.managers), function(manager) {
    return _c('span', {
      staticClass: "manager"
    }, [_vm._v(_vm._s(manager))])
  })], 2) : _vm._e(), (_vm.day.schedule && _vm.day.schedule !== '') ? _c('div', {
    staticClass: "schedule"
  }, [_c('h3', [_vm._v("Tagesablauf")]), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$options.filters.linebreaks(_vm.day.schedule))
    }
  })]) : _vm._e(), (_vm.day.documents.length > 0) ? _c('div', {
    staticClass: "documents"
  }, [_c('h3', [_vm._v("Dokumente")]), _c('ul', {
    staticClass: "files"
  }, _vm._l((_vm.day.documents), function(doc) {
    return _c('li', [_c('a', {
      attrs: {
        "href": doc.url,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa",
      class: doc.icon
    }), _vm._v(" " + _vm._s(doc.name))])])
  }), 0)]) : _vm._e(), _vm._l((_vm.day.shifts), function(shift, index) {
    return _c('shift', {
      key: shift.id,
      class: {
        'gray': index % 2 === 0
      },
      attrs: {
        "shift": shift
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f77f8ce"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PlannedDay.vue
// module id = 1078
// module chunks = 1